import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

// User Manager (and Superadmin) guard for /user-manager/*
const ProtectedUserManagerRoute = ({ children }) => {
  const { loading, adminRole, user } = useAuth();

  if (loading) return null;

  const allowed = adminRole === 'user_manager' || adminRole === 'superadmin' || !!user?.is_superadmin;

  if (!allowed) {
    return <Navigate to="/admin/login" replace />;
  }
  return children;
};

export default ProtectedUserManagerRoute;